import Promise from 'bluebird';
import * as Rx from 'rx';
var CacheLayer = (function () {
    function CacheLayer() {
    }
    Object.defineProperty(CacheLayer, "storage", {
        get: function () {
            if (!CacheLayer._storage) {
                if (localStorage) {
                    CacheLayer._storage = localStorage;
                }
                else if (sessionStorage) {
                    CacheLayer._storage = sessionStorage;
                }
                else {
                    return { getItem: function (key) { return null; }, setItem: function (key, value) { }, removeItem: function (key) { } };
                }
            }
            return CacheLayer._storage;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CacheLayer, "cacheDeactivated", {
        get: function () {
            if (CacheLayer._cacheDeactivated === null) {
                CacheLayer._cacheDeactivated = !!CacheLayer.storage.getItem("cl$inactive");
            }
            return CacheLayer._cacheDeactivated;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CacheLayer, "prefix", {
        get: function () {
            try {
                return CacheLayer._prefix.toString();
            }
            catch (_a) {
                CacheLayer._prefix = CacheLayer._prefixPrefix + _spPageContextInfo.systemUserKey + '|';
                CacheLayer.clearCache(CacheLayer._prefix);
                return CacheLayer._prefix;
            }
        },
        enumerable: true,
        configurable: true
    });
    CacheLayer.clearCache = function (prefix, maxAgeInDays) {
        if (maxAgeInDays === void 0) { maxAgeInDays = 30; }
        var cacheKeys = Object.keys(CacheLayer.storage);
        var prefixLength = prefix.length;
        var prefixPrefixLength = CacheLayer._prefixPrefix.length;
        var maxDate = new Date(new Date().getTime() - maxAgeInDays * 24 * 60 * 60 * 1000);
        for (var index in cacheKeys) {
            var cacheKey = cacheKeys[index];
            if (cacheKey.substr(0, prefixPrefixLength) == CacheLayer._prefixPrefix) {
                if (cacheKey.substr(0, prefixLength) != prefix) {
                    CacheLayer.storage.removeItem(cacheKey);
                }
                else {
                    var data = CacheLayer.getFromCache(cacheKey, false);
                    if (data.expire < maxDate) {
                        CacheLayer.storage.removeItem(cacheKey);
                    }
                }
            }
        }
    };
    CacheLayer.reload = function (action, key, timeoutInMinutes) {
        if (timeoutInMinutes === void 0) { timeoutInMinutes = 5; }
        CacheLayer.clear(key);
        return CacheLayer.load(action, key, timeoutInMinutes);
    };
    CacheLayer.load = function (action, key, timeoutInMinutes) {
        if (timeoutInMinutes === void 0) { timeoutInMinutes = 5; }
        var subject = new Rx.ReplaySubject();
        var expire = null;
        var data = null;
        if (!CacheLayer.cacheDeactivated) {
            var cachedData = CacheLayer.getFromCache(key);
            if (cachedData) {
                expire = cachedData.expire;
                data = cachedData.data;
            }
        }
        if (!expire) {
            CacheLayer.loadFromAction(action, key, timeoutInMinutes)
                .then(function (data) {
                subject.onNext(data);
                subject.onCompleted();
            })
                .catch(function (err) {
                subject.onCompleted();
            });
        }
        else if (expire < new Date()) {
            CacheLayer.loadFromAction(action, key, timeoutInMinutes)
                .then(function (data) {
                subject.onNext(data);
                subject.onCompleted();
            })
                .catch(function (err) {
                subject.onCompleted();
            });
            subject.onNext(data);
        }
        else {
            subject.onNext(data);
            subject.onCompleted();
        }
        return subject.asObservable();
    };
    CacheLayer.loadFromAction = function (action, key, timeoutInMinutes) {
        return action()
            .then(function (data) {
            var dataString = new Date(new Date().getTime() + timeoutInMinutes * 60 * 1000).toISOString() + '|' + JSON.stringify(data);
            CacheLayer.storage.setItem(CacheLayer.prefix + key, dataString);
            return data;
        })
            .catch(function (ex) {
            debugger;
            return Promise.resolve(null);
        });
    };
    CacheLayer.getFromCache = function (key, prependPrefix) {
        if (prependPrefix === void 0) { prependPrefix = true; }
        var dataString = CacheLayer.storage.getItem((prependPrefix ? CacheLayer.prefix : '') + key);
        if (dataString) {
            var splitIndex = dataString.indexOf('|');
            if (splitIndex < 0) {
                return {};
            }
            try {
                var expire = new Date(Date.parse(dataString.substring(0, splitIndex)));
                var data = JSON.parse(dataString.substring(splitIndex + 1));
                return { expire: expire, data: data };
            }
            catch (ex) {
                return {};
            }
        }
        return {};
    };
    CacheLayer.simpleLoad = function (action, key, timeoutInMinutes) {
        if (timeoutInMinutes === void 0) { timeoutInMinutes = 5; }
        var _a = CacheLayer.getFromCache(key), expire = _a.expire, data = _a.data;
        if (!expire || expire < new Date()) {
            return CacheLayer.loadFromAction(action, key, timeoutInMinutes);
        }
        else {
            return Promise.resolve(data);
        }
    };
    CacheLayer.simpleReload = function (action, key, timeoutInMinutes) {
        if (timeoutInMinutes === void 0) { timeoutInMinutes = 5; }
        CacheLayer.clear(key);
        return CacheLayer.simpleLoad(action, key, timeoutInMinutes);
    };
    CacheLayer.clear = function (key) {
        CacheLayer.storage.removeItem(CacheLayer.prefix + key);
    };
    CacheLayer._prefixPrefix = 'cl|';
    CacheLayer._cacheDeactivated = null;
    CacheLayer._prefix = null;
    return CacheLayer;
}());
export default CacheLayer;
